import DatasetTable, { datasetTableColumns } from "@/components/DatasetTable/DatasetTable";
import EcoInventDatasetSelector from "@/components/EcoInventDatasetSelector/EcoInventDatasetSelector";
import Message from "@/components/Message/Message";
import PageButtonGroup from "@/components/PageButtonGroup/PageButtonGroup";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import useTableStateUrl from "@/components/Table/hooks/useTableStateUrl";
import TableHeader from "@/components/TableHeader/TableHeader";
import useAnalytics from "@/hooks/useAnalytics";
import { useImpactDatasets } from "@/hooks/useEcoInventDatasets";
import { useUserSettings } from "@/hooks/useUserSettings";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

export default function RootReferences() {
  const analytics = useAnalytics();
  const navigate = useNavigate();
  const { data: userSettings } = useUserSettings();

  analytics.track("Root References Overview Viewed");

  const columns = [...datasetTableColumns.filter((x) => x.key !== "dataset_type")];

  const { pagination, filter, search, sort, onSearchFilterSortPaginate } = useTableStateUrl({
    columns,
    defaultPagination: { page: 1, pageSize: 20 },
  });

  const newSearch = { dataset_type: "root", ...search };

  const { data, isLoading, isFetching } = useImpactDatasets({
    pagination,
    filter,
    search: newSearch,
    sort,
  });

  if (userSettings && userSettings?.role !== "root_admin") {
    return <Message type="error">You do not have access to this page.</Message>;
  }

  return (
    <div>
      <PageHeader
        title="Root impact references"
        description="Create and manage your own impact references tailored to your specific materials or processes."
      />
      <div>
        <TableHeader
          left={
            <PageButtonGroup>
              <EcoInventDatasetSelector
                onSelect={(dataset) =>
                  navigate("/admin/root_impact_references/create/" + dataset.id)
                }
              >
                <Button>
                  <PlusOutlined />
                  Add root impact reference
                </Button>
              </EcoInventDatasetSelector>
            </PageButtonGroup>
          }
        />
        <DatasetTable
          columns={columns}
          totalRows={data?.total_count}
          onSearchFilterSortPaginate={onSearchFilterSortPaginate}
          pagination={pagination}
          data={data?.datasets}
          filter={filter}
          search={search}
          sort={sort}
          loading={isLoading || isFetching}
          rowLink={(record) => `/admin/root_impact_references/${record.id}`}
        />
      </div>
    </div>
  );
}
